import { mapProfileToAuthUser } from '../utils/map-profile'
import type { ApiSuccess } from '@/lib/api'
import type { AuthUser, MeProfile } from '../types'
import { http } from '@/lib/api'

/**
 * REST calls for the shared `/auth/*` endpoints. Admin sign-in lives in its
 * own service (`adminAuthApi`, swagger/admin-auth.json).
 */
export const authApi = {
  /**
   * Fetch the current profile and map it to `AuthUser`. Pass
   * `accessToken` to authenticate a token that is not yet in the store
   * (used by the URL-hash handoff); an explicit header takes precedence
   * over the ambient store token in the request interceptor.
   */
  me: (accessToken?: string): Promise<AuthUser> =>
    http
      .get<
        ApiSuccess<MeProfile>
      >('/auth/me', accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : undefined)
      .then((res) => mapProfileToAuthUser(res.data)),

  /** Invalidate the session server-side. */
  logout: () => http.post<void>('/auth/logout'),
}
